module.exports = __webpack_public_path__ + "static/media/YM67_3.429f6d7a.jpg";